import axios from 'axios'

export const axiosIntance = axios.create({
    baseURL : "https://lmsccb-api-hdg0h3ekbcg9anet.canadacentral-01.azurewebsites.net/api/v1",
    withCredentials : true
})